// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"fd4c5033","197":"83d30c32","261":"2b764a5d","397":"232ad3d3","430":"37557a11","490":"892ff82d","693":"efcd520a","942":"a9d1efb1"}[chunkId] + ".chunk.css";
};